import { useTranslation } from 'react-i18next';
import { Logo, YWCLogoSmall, useTheme } from '@ui';

export const YWCAppLogo = () => {
  const { t } = useTranslation();
  const { bgColorSecondary } = useTheme();

  return (
    <div className="flex items-end gap-0">
      <div className="flex items-end gap-1">
        <YWCLogoSmall className="h-14 w-auto" />
      </div>

      <div className="flex sm:flex-row items-end sm:items-end gap-2 mb-[3px]">
        <div className="flex flex-col gap-1">
          <div className="text-black text-[10px] leading-none">{t('common.powered_by')}:</div>

          <Logo className="h-6 block w-auto text-black" />
        </div>
        <span
          className="text-[8px] leading-none text-base-100 rounded-lg px-1 py-[2px] w-fit"
          style={{ backgroundColor: bgColorSecondary }}
        >
          {t('common.beta')}
        </span>
      </div>
    </div>
  );
};
